import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { Hidden } from "@material-ui/core";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider as MuiThemeProvider } from "@material-ui/core/styles";

import DataCalendar from "./UsageDataCalendarCard.jsx";
import DataGraphic from "./UsageDataGraphicCard.jsx";
import MobileDataCalendar from "./MobileCalendarCard";
import MobileDataGraphic from "./UsageDataGraphicCardMobile.jsx";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  const theme = createMuiTheme({
    overrides: {
      MuiBox: {
        root: {
          padding: "0px",
        },
      },
    },
  });

  return (
    <MuiThemeProvider theme={theme}>
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box p={3}>{children}</Box>}
      </Typography>
    </MuiThemeProvider>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
}));

const tabsStyle = {
  backgroundColor: "#ffffff",
  color: "#27aae1",
};

export default function SimpleTabs() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  let start = new Date();
  start.setHours(0, 0, 0, 0);
  let graphicStartInitial = start.getTime() / 1000;

  const [graphicStart, setGraphicStart] = useState(graphicStartInitial);
  const [graphType, setGraphType] = useState("all");

  return (
    <div className={classes.root}>
      <Tabs
        style={tabsStyle}
        value={value}
        onChange={handleChange}
        indicatorColor="primary"
      >
        <Tab label="Calendar" {...a11yProps(0)} />
        <Tab label="Data Usage" {...a11yProps(1)} />
      </Tabs>
      <TabPanel value={value} index={0}>
        <Hidden xsDown>
          <DataCalendar
            changesTabs={handleChange}
            focusDate={(ts, type) => {
              setGraphicStart(ts);
              setGraphType(type);
            }}
          />
        </Hidden>
        <Hidden smUp>
          <MobileDataCalendar
            changesTabs={handleChange}
            focusDate={(ts, type) => {
              setGraphicStart(ts);
              setGraphType(type);
            }}
          />
        </Hidden>
      </TabPanel>
      <TabPanel value={value} index={1}>
        <Hidden xsDown>
          <DataGraphic
            graphType={graphType}
            pathids={{
              broadbandgraphic: graphicStart,
            }}
          />
        </Hidden>
        <Hidden smUp>
          <MobileDataGraphic
            graphType={graphType}
            pathids={{
              broadbandgraphic: graphicStart,
            }}
          />
        </Hidden>
      </TabPanel>
      <h4 style={{color: "red"}}>Calendar and Data Usage information is used for educational purposes only. The Dashboard tab provides the most accurate information for billing.</h4>
    </div>
  );
}
